module.exports = __webpack_public_path__ + "static/media/all-tenderness.aa5b17db.mp3";